import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Convert FastAPI 422 error arrays to a readable string
export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export function formatINR(n, opts = {}) {
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  const { decimals = 2, sign = false } = opts;
  const abs = Math.abs(n);
  const formatted = abs.toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  const s = `₹${formatted}`;
  if (sign) return n >= 0 ? `+${s}` : `-${s}`;
  return n < 0 ? `-${s}` : s;
}

export function formatPct(n, decimals = 2) {
  if (n === null || n === undefined || isNaN(n)) return "0%";
  const s = n >= 0 ? "+" : "";
  return `${s}${n.toFixed(decimals)}%`;
}
